import React, { useState, useEffect } from "react";
import { SketchPicker } from "react-color";
import "./Canvas Properties.css";
import Checkbox from "@mui/material/Checkbox";
import SingleSelectDropdown from "../Common Components/SingleSelectDropdown";
import { Tooltip } from "@mui/material";
import { MdRemove } from "react-icons/md";

const CanvasProperties = ({
  nodeId,
  nodeColor,
  fontColor: propFontColor,
  edgeId,
  onUpdateNode,
  type,
  edgeLabel,
  edgeStyles,
  onUpdateEdge,
  currentTab,
}) => {
  const [initalEdgeLabel, setInitialEdgeLabel] = useState("");
  const [edgeStyle, setEdgeStyle] = useState({});
  const [edgeAnimation, setEdgeAnimation] = useState(false);

  const [color, setColor] = useState("#fff");
  const [fontColor, setFontColor] = useState("#000000");
  const [fontSize, setFontSize] = useState(14);

  const [displayNodeColorPicker, setDisplayNodeColorPicker] = useState(false);
  const [displayFontColorPicker, setDisplayFontColorPicker] = useState(false);

  const [edgeStyleChecked, setEdgeStyleChecked] = useState(false);
  const [edgeAnimationChecked, setEdgeAnimationCheckedState] = useState(false);

  const [valueDropdown, setvalueDropdown] = useState([]);

  const configOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];
  useEffect(() => {
    if (nodeId) {
      setColor(nodeColor || "#fff");
    }
  }, [nodeColor]);
  useEffect(() => {
    if (propFontColor) {
      setFontColor(propFontColor || "#000000");
    }

  }, [propFontColor]);
  useEffect(() => {
    setInitialEdgeLabel(edgeLabel || "");
    const selectedOption = configOptions.find(
      (option) => option.label === edgeLabel
    );
    setvalueDropdown(selectedOption ? [selectedOption] : []);
  }, [edgeLabel]);

  // ✅ Apply updates to node and edge
  const handleButton = () => {
    if (nodeId) {
      onUpdateNode(
        nodeId,
        null, // label
        null, // icon
        color, // node background color
        null,
        null,
        null,
        null,
        null,
        fontColor, // font color
        fontSize // font size
      );
    }

    if (edgeId) {
      onUpdateEdge(edgeId, initalEdgeLabel, edgeStyle, edgeAnimation);
    }
  };

  const handleColorChange = (color) => setColor(color.hex);
  const handleFontColorChange = (color) => setFontColor(color.hex);

  const handleCheckChange = (value) => {
    if (value === "edgeStyle") setEdgeStyleChecked(!edgeStyleChecked);
    if (value === "edgeAnimation") setEdgeAnimationCheckedState(!edgeAnimationChecked);
  };

  useEffect(() => {
    setEdgeStyle(
      edgeStyleChecked
        ? { position: "relative", strokeDasharray: "5,5" }
        : { position: "relative", strokeDasharray: "0,0" }
    );
    setEdgeAnimation(edgeAnimationChecked);
  }, [edgeStyleChecked, edgeAnimationChecked]);

  const handleDropdownChange = (value) => {
    setvalueDropdown(value);
    setInitialEdgeLabel(value.label);
  };

  const clearEdgeLabel = () => {
    setvalueDropdown([]);
    setInitialEdgeLabel("");
  };

  return (
    
    <div className="property-tab">
      {/* EDGE PROPERTIES */}
    
      {edgeId && (
        <>
          {currentTab === "Subflow" && (
            <>
              <p style={{ fontSize: "14px" }}>Edge Label :</p>

              <div style={{ display: "flex", gap: "10px" }}>
                <SingleSelectDropdown
                  options={configOptions}
                  onChange={(value) => handleDropdownChange(value)}
                  valueSet={valueDropdown}
                  placeHolder="Select edge label..."
                />
                <Tooltip title="Clear Edge Label">
                  <MdRemove
                    size="25px"
                    style={{
                      background: "#ff0000",
                      borderRadius: "50%",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={clearEdgeLabel}
                  />
                </Tooltip>
              </div>
            </>
          )}

          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <p>Edge Stroke Style :</p>
            <p>Dashed</p>
            <Checkbox
              checked={edgeStyleChecked}
              onChange={() => handleCheckChange("edgeStyle")}
              sx={{
                color: "#02acf6",
                "&.Mui-checked": { color: "#02acf6" },
              }}
            />
          </div>

          {edgeStyleChecked && (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <p>Edge Animation :</p>
              <p>Animated</p>
              <Checkbox
                checked={edgeAnimationChecked}
                onChange={() => handleCheckChange("edgeAnimation")}
                sx={{
                  color: "#02acf6",
                  "&.Mui-checked": { color: "#02acf6" },
                }}
              />
            </div>
          )}
        </>
      )}

      {/* NODE PROPERTIES */}
      {nodeId && (
        <>
        
          <div className="color-division">
            {/* Node Color */}
           
            <div style={{ display: "flex", gap: "10px" }}>
              <p>Node Color :</p>
              <div
                className="color-code"
                onClick={() => setDisplayNodeColorPicker(!displayNodeColorPicker)}
              >
                <p
                  style={{
                    backgroundColor: color,
                    padding: "5px",
                    borderRadius: "4px",
                    color: "#fff",
                  }}
                >
                  {color}
                </p>
              </div>
            </div>

            {displayNodeColorPicker && (
              <div style={{ position: "fixed", zIndex: 9999 }}>
                <div
                  style={{ position: "fixed", inset: 0 }}
                  onClick={() => setDisplayNodeColorPicker(false)}
                />
                <SketchPicker color={color} onChange={handleColorChange} />
              </div>
            )}

            {/* Font Color */}
            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              <p>Font Color :</p>
              <div
                className="color-code"
                onClick={() => setDisplayFontColorPicker(!displayFontColorPicker)}
              >
                <p
                  style={{
                    backgroundColor: fontColor,
                    padding: "5px",
                    borderRadius: "4px",
                    color: "#fff",
                  }}
                >
                  {fontColor}
                </p>
              </div>
            </div>

            {displayFontColorPicker && (
              <div style={{ position: "fixed", zIndex: 9999 }}>
                <div
                  style={{ position: "fixed", inset: 0 }}
                  onClick={() => setDisplayFontColorPicker(false)}
                />
                <SketchPicker color={fontColor} onChange={handleFontColorChange} />
              </div>
            )}

            {/* Font Size */}
            {/* <div style={{ marginTop: "10px" }}>
              <p>Font Size :</p>
              <input
                type="number"
                value={fontSize}
                min="10"
                max="40"
                onChange={(e) => setFontSize(Number(e.target.value))} // ✅ Convert to number
                style={{
                  width: "80px",
                  padding: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div> */}
            <button type="button" onClick={handleButton} style={{ marginTop: "20px", width: "200px" }}>
              OK
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CanvasProperties;